app.controller("StudentTableController", ["$scope", "StSubject", "Users", "Session", "StaticData",
    function ($scope, StSubject, Users, Session, StaticData) {

        StaticData.getItemsByKey("days").then(function (days) {
            $scope.days = days;
            $scope.daysMap = _.keyBy($scope.days, '_id');
        });

        StaticData.getItemsByKey("session_types").then(function (sessionTypes) {
            $scope.sessionTypes = sessionTypes;
            $scope.sessionTypesMap = _.keyBy($scope.sessionTypes, '_id');
        });

        load();

        function load() {
            Session.studentSessions().then(function (sessions) {
                sessions.map(function (session) {
                    if (session.dayOfWeek) session.day = $scope.daysMap[session.dayOfWeek].name;
                    if (session.sessionGroup.lecturer) session.lecturer = session.sessionGroup.lecturer.user.firstName + " " + session.sessionGroup.lecturer.user.lastName;
                    if (session.sessionGroup.sessionType) session.type = $scope.sessionTypesMap[session.sessionGroup.sessionType].name;
                    if (session.sessionGroup.subjectWrapper) session.subject = session.sessionGroup.subjectWrapper.name;
                });
                $scope.sessions = sessions;
            })
        }
    }
]);